import { getSize, getColor, styleVariables } from '@lib/common';
import styled from 'styled-components';
import { Skeleton, Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledHeader = styled.div.withConfig({
  displayName: "headercomponent__StyledHeader",
  componentId: "sc-1mblw91-0"
})(["display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:", ";border-bottom:2px solid ", ";box-shadow:0px 2px 4px rgba(0,0,0,0.08);"], getSize('padding12'), styleVariables.colors.gray6);
var StyledHeaderWrapper = styled.div.withConfig({
  displayName: "headercomponent__StyledHeaderWrapper",
  componentId: "sc-1mblw91-1"
})(["display:flex;flex-direction:column;gap:", ";"], getSize('padding8'));
var StyledTrophyIconWrapper = styled.div.withConfig({
  displayName: "headercomponent__StyledTrophyIconWrapper",
  componentId: "sc-1mblw91-2"
})(["width:28px;height:28px;border-radius:", ";background-color:", ";color:", ";display:flex;align-items:center;justify-content:center;svg{font-size:", ";}"], getSize('radiusS'), getColor('fillIntHighlighted'), getColor('textIntHighlighted'), getSize('typo16'));
var StyledHeaderTitle = styled.div.withConfig({
  displayName: "headercomponent__StyledHeaderTitle",
  componentId: "sc-1mblw91-3"
})(["display:flex;flex-direction:column;font-size:", ";font-weight:500;color:", ";text-transform:uppercase;"], getSize('typo10'), getColor('textIntSub'));
var StyledHeaderValue = styled.span.withConfig({
  displayName: "headercomponent__StyledHeaderValue",
  componentId: "sc-1mblw91-4"
})(["font-size:", ";font-weight:700;color:", ";line-height:1;"], getSize('typo18'), function (_ref) {
  var $color = _ref.$color;
  return $color || getColor('contentTitle');
});
var StyledVerticalDivider = styled.div.withConfig({
  displayName: "headercomponent__StyledVerticalDivider",
  componentId: "sc-1mblw91-5"
})(["width:1px;height:32px;background-color:#e2e8f0;margin:0 ", ";"], getSize('padding16'));
var StyledSkeleton = styled(Skeleton.Button).withConfig({
  displayName: "headercomponent__StyledSkeleton",
  componentId: "sc-1mblw91-6"
})(["width:60px;height:24px;margin-top:", ";"], getSize('padding4'));
var StyledHeaderContent = styled.div.withConfig({
  displayName: "headercomponent__StyledHeaderContent",
  componentId: "sc-1mblw91-7"
})(["display:flex;flex-direction:column;align-items:", ";gap:", ";"], function (_ref2) {
  var $placement = _ref2.$placement;
  return $placement === 'right' ? 'flex-end' : 'flex-start';
}, getSize('padding4'));
export var HeaderComponent = function HeaderComponent(_ref3) {
  var pointIcon = _ref3.pointIcon,
      totalQuestionScore = _ref3.totalQuestionScore,
      totalQuestions = _ref3.totalQuestions,
      labelTranslation = _ref3.labelTranslation;

  var renderTotalScore = function renderTotalScore() {
    var isLoadingPoints = totalQuestionScore === null || totalQuestionScore === undefined;

    if (isLoadingPoints) {
      return /*#__PURE__*/_jsx(StyledSkeleton, {
        active: true,
        size: "small"
      });
    }

    return /*#__PURE__*/_jsx(StyledHeaderValue, {
      $color: "#2762EA",
      children: totalQuestionScore !== null && totalQuestionScore !== void 0 ? totalQuestionScore : 0
    });
  };

  var renderTotalQuestions = function renderTotalQuestions() {
    var isLoadingQuestions = totalQuestions === null || totalQuestions === undefined;

    if (isLoadingQuestions) {
      return /*#__PURE__*/_jsx(StyledSkeleton, {
        active: true,
        size: "small"
      });
    }

    return /*#__PURE__*/_jsx(StyledHeaderValue, {
      children: totalQuestions !== null && totalQuestions !== void 0 ? totalQuestions : 0
    });
  };

  return /*#__PURE__*/_jsxs(StyledHeader, {
    children: [/*#__PURE__*/_jsx(StyledHeaderWrapper, {
      children: /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(StyledTrophyIconWrapper, {
          children: pointIcon
        }), /*#__PURE__*/_jsxs(StyledHeaderContent, {
          children: [/*#__PURE__*/_jsx(StyledHeaderTitle, {
            children: labelTranslation.totalPoints || 'POINTS'
          }), renderTotalScore()]
        })]
      })
    }), /*#__PURE__*/_jsx(StyledVerticalDivider, {}), /*#__PURE__*/_jsx(StyledHeaderWrapper, {
      children: /*#__PURE__*/_jsxs(StyledHeaderContent, {
        $placement: "right",
        children: [/*#__PURE__*/_jsx(StyledHeaderTitle, {
          children: labelTranslation.totalQuestions || 'QUESTIONS'
        }), renderTotalQuestions()]
      })
    })]
  });
};